import { render, staticRenderFns } from "./ChipList.vue?vue&type=template&id=276776e4&scoped=true"
import script from "./ChipList.vue?vue&type=script&lang=js"
export * from "./ChipList.vue?vue&type=script&lang=js"
import style0 from "./ChipList.vue?vue&type=style&index=0&id=276776e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276776e4",
  null
  
)

export default component.exports